// app/javascript/modules/ferias/agendadas_actions.js

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? "";
}

function turboReload() {
  if (typeof Turbo !== 'undefined') {
    Turbo.clearCache();
    Turbo.visit(window.location.href, { action: 'replace' });
  } else {
    window.location.reload();
  }
}

async function swalConfirm(opts) {
  if (typeof window.Swal !== "undefined") return Swal.fire(opts);
  const ok = window.confirm((opts.title ? opts.title + "\n\n" : "") + (opts.text ?? "Confirmar?"));
  return { isConfirmed: ok };
}

async function swalInfo(opts) {
  if (typeof window.Swal !== "undefined") return Swal.fire(opts);
  alert((opts.title ? opts.title + "\n\n" : "") + (opts.text ?? ""));
}

async function fetchJson(url, options = {}) {
  const token = csrfToken();
  const resp = await fetch(url, {
    ...options,
    credentials: "same-origin",
    headers: { "X-CSRF-Token": token, ...(options.headers ?? {}) },
  });
  if (!resp.ok) throw resp;
  const ct = resp.headers.get("content-type") ?? "";
  return ct.includes("json") ? resp.json() : resp.text();
}

// -------------------------------------------------------
// Accordion — Ver Histórico de Férias
// -------------------------------------------------------
async function handleAccordion(btn) {
  const funcId      = btn.dataset.funcionarioId;
  const condominioId = btn.dataset.condominioId;
  const chapa       = btn.dataset.chapa;
  const linha       = document.getElementById(`historico_ferias_${funcId}`);
  const tbody       = document.getElementById(`tbody-historico-${funcId}`);
  const textEl      = btn.querySelector(".accordion-text");

  if (!linha || !tbody) return;

  // Toggle visibilidade
  const isVisible = linha.style.display !== "none";
  if (isVisible) {
    linha.style.display = "none";
    if (textEl) textEl.textContent = "Ver histórico";
    return;
  }

  linha.style.display = "table-row";
  if (textEl) textEl.textContent = "Ocultar histórico";

  if (tbody.dataset.carregado) return;

  tbody.innerHTML = `<tr><td colspan="4" class="text-center py-5 text-sm text-gray-400">Carregando...</td></tr>`;

  try {
    const params = new URLSearchParams({ condominio_id: condominioId, chapa });
    const rawData = await fetchJson(`/movimentacoes_pessoais/historico_ferias?${params}`);

    if (!rawData || rawData.length === 0) {
      tbody.innerHTML = `<tr><td colspan="4" class="text-center py-6 text-sm text-gray-400">Nenhum histórico encontrado.</td></tr>`;
      tbody.dataset.carregado = "true";
      return;
    }

    function val(d) { return (d && String(d).trim()) ? String(d).trim() : "—"; }

    // Converte "dd/mm/yyyy" → Date para comparação
    function parseDate(str) {
      if (!str || str === "—") return new Date(0);
      const p = str.split("/");
      return p.length === 3 ? new Date(p[2], p[1] - 1, p[0]) : new Date(str);
    }

    // Colunas ordenáveis: índice → chave no objeto
    const COLS = [
      "periodo_aquisitivo_data_de_inicio",
      "periodo_aquisitivo_data_fim",
      "perido_gozo_data_de_inicio",   // typo vindo do servidor
      "periodo_gozo_data_fim",
    ];

    // Estado de ordenação — padrão: coluna 0 descendente (mais recente primeiro)
    let sortCol = 0;
    let sortDir = "desc";

    function sorted() {
      return [...rawData].sort((a, b) => {
        const da = parseDate(val(a[COLS[sortCol]]));
        const db = parseDate(val(b[COLS[sortCol]]));
        return sortDir === "asc" ? da - db : db - da;
      });
    }

    function arrow(col) {
      if (col !== sortCol) {
        return `<span class="ml-1 text-gray-300 text-xs">⇅</span>`;
      }
      return sortDir === "asc"
        ? `<span class="ml-1 text-blue-500 text-xs">↑</span>`
        : `<span class="ml-1 text-blue-500 text-xs">↓</span>`;
    }

    function render() {
      const thSort = "px-4 py-2.5 text-xs font-semibold uppercase tracking-wide text-gray-500 cursor-pointer select-none hover:bg-gray-200 transition-colors text-center";
      const thGroup = "px-4 py-2 text-center text-xs font-semibold uppercase tracking-wide text-gray-500";

      const header = `
        <tr class="bg-gray-100 border-b border-gray-200">
          <th colspan="2" class="${thGroup} border-r border-gray-200">Período Aquisitivo</th>
          <th colspan="2" class="${thGroup}">Período de Gozo</th>
        </tr>
        <tr class="bg-gray-50 border-b border-gray-200">
          <th data-sort-col="0" class="${thSort}">Início${arrow(0)}</th>
          <th data-sort-col="1" class="${thSort} border-r border-gray-200">Fim${arrow(1)}</th>
          <th data-sort-col="2" class="${thSort}">Início${arrow(2)}</th>
          <th data-sort-col="3" class="${thSort}">Fim${arrow(3)}</th>
        </tr>`;

      const td = "px-4 py-3 text-sm text-gray-700 text-center";
      const rows = sorted().map((f, i) => {
        const bg = i % 2 === 0 ? "bg-white" : "bg-gray-50";
        const gozoIni = val(f.perido_gozo_data_de_inicio);
        const gozoFim = val(f.periodo_gozo_data_fim);
        const semGozo = gozoIni === "—" && gozoFim === "—";
        const gozoCells = semGozo
          ? `<td colspan="2" class="${td} italic text-gray-400">Pendente de agendamento</td>`
          : `<td class="${td}">${gozoIni}</td><td class="${td}">${gozoFim}</td>`;
        return `<tr class="${bg} hover:bg-blue-50 transition-colors border-b border-gray-100 last:border-0">
          <td class="${td}">${val(f.periodo_aquisitivo_data_de_inicio)}</td>
          <td class="${td} border-r border-gray-200">${val(f.periodo_aquisitivo_data_fim)}</td>
          ${gozoCells}
        </tr>`;
      }).join("");

      tbody.innerHTML = header + rows;
    }

    // Delegação de clique para ordenação (listener no tbody persiste entre re-renders)
    tbody.addEventListener("click", (e) => {
      const th = e.target.closest("[data-sort-col]");
      if (!th) return;
      const col = parseInt(th.dataset.sortCol, 10);
      if (col === sortCol) {
        sortDir = sortDir === "asc" ? "desc" : "asc";
      } else {
        sortCol = col;
        sortDir = "desc"; // nova coluna começa sempre descendente
      }
      render();
    });

    render();
    tbody.dataset.carregado = "true";

  } catch {
    tbody.innerHTML = `<tr><td colspan="4" class="text-center py-6 text-sm text-red-500">Erro ao carregar histórico.</td></tr>`;
  }
}

// -------------------------------------------------------
// Cancelar Férias
// -------------------------------------------------------
const MSG_JA_PAGO =
  "As férias deste funcionário já foram pagas e não é possível fazer alterações.";

async function handleCancelarFerias(btn) {
  const url = btn.dataset.url;
  if (!url) return;

  if (btn.dataset.jaPago === "true") {
    await swalInfo({ title: "Férias já pagas", html: MSG_JA_PAGO, icon: "info" });
    return;
  }

  const result = await swalConfirm({
    title: "Cancelar Férias",
    text: "Confirma o cancelamento das férias deste funcionário?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sim, cancelar",
    cancelButtonText: "Voltar",
  });
  if (!result.isConfirmed) return;

  btn.disabled = true;
  try {
    const resp = await fetchJson(url, { method: "POST" });
    await swalInfo({
      title: "Sucesso!",
      text: (resp && resp.mensagem) ? resp.mensagem : "Férias canceladas com sucesso.",
      icon: "success",
    });
    turboReload();
  } catch (err) {
    let titulo = "Erro!";
    let mensagem = "Não foi possível cancelar as férias.";
    let icone = "error";

    try {
      const data = await err.json();
      if (data.tipo === "prazo_expirado") {
        titulo  = "Atenção";
        mensagem = data.mensagem;
        icone   = "warning";
      } else if (data.mensagem) {
        mensagem = data.mensagem;
      }
    } catch {}

    await swalInfo({ title: titulo, html: mensagem, icon: icone });
    btn.disabled = false;
  }
}

// -------------------------------------------------------
// Mudar data de pagamento (reagendar)
// -------------------------------------------------------
async function handleReagendar(btn) {
  const url = btn.dataset.url;
  if (!url) return;

  if (btn.dataset.jaPago === "true") {
    await swalInfo({ title: "Férias já pagas", html: MSG_JA_PAGO, icon: "info" });
    return;
  }

  let novaData;

  if (typeof window.Swal !== "undefined") {
    const result = await Swal.fire({
      title: "Mudar data de pagamento",
      html: `<input id="swal-nova-data" type="text" inputmode="numeric"
               placeholder="DD/MM/AAAA" maxlength="10"
               class="swal2-input" style="width:auto;letter-spacing:0.05em">`,
      showCancelButton: true,
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
      didOpen: () => {
        const input = document.getElementById("swal-nova-data");
        input.addEventListener("input", () => {
          let v = input.value.replace(/\D/g, "");
          if (v.length > 2) v = v.slice(0,2) + "/" + v.slice(2);
          if (v.length > 5) v = v.slice(0,5) + "/" + v.slice(5);
          input.value = v.slice(0, 10);
        });
        input.focus();
      },
      preConfirm: () => {
        const val = document.getElementById("swal-nova-data").value;
        const match = val.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
        if (!match) {
          Swal.showValidationMessage("Informe a data no formato DD/MM/AAAA.");
          return false;
        }
        const [, d, m, y] = match;
        const date = new Date(`${y}-${m}-${d}`);
        if (isNaN(date.getTime())) {
          Swal.showValidationMessage("Data inválida.");
          return false;
        }
        // Valida que a data de pagamento não é posterior ao início das férias
        if (btn.dataset.inicio) {
          const inicioFerias = new Date(btn.dataset.inicio);
          if (!isNaN(inicioFerias.getTime()) && date > inicioFerias) {
            const inicioFmt = inicioFerias.toLocaleDateString("pt-BR");
            Swal.showValidationMessage(`A data de pagamento não pode ser posterior ao início das férias (${inicioFmt}).`);
            return false;
          }
        }
        // Retorna no formato esperado pelo controller (YYYY-MM-DD)
        return `${y}-${m}-${d}`;
      },
    });
    if (!result.isConfirmed) return;
    novaData = result.value;
  } else {
    novaData = window.prompt("Nova data de pagamento (DD/MM/AAAA):");
    if (!novaData) return;
    const match = novaData.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!match) { alert("Formato inválido."); return; }
    novaData = `${match[3]}-${match[2]}-${match[1]}`;
  }

  btn.disabled = true;
  try {
    const resp = await fetchJson(url, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: `data=${encodeURIComponent(novaData)}`,
    });
    await swalInfo({
      title: "Sucesso!",
      text: (resp && resp.mensagem) ? resp.mensagem : "Data de pagamento alterada.",
      icon: "success",
    });
    turboReload();
  } catch (err) {
    let titulo   = "Erro!";
    let mensagem = "Não foi possível mudar a data de pagamento.";
    let icone    = "error";
    try {
      const data = await err.json();
      if (data.tipo === "prazo_expirado") {
        titulo   = "Atenção";
        mensagem = data.mensagem;
        icone    = "warning";
      } else if (data.mensagem) {
        mensagem = data.mensagem;
      }
    } catch {}
    await swalInfo({ title: titulo, html: mensagem, icon: icone });
    btn.disabled = false;
  }
}

// -------------------------------------------------------
// Verificar documentos existentes
// -------------------------------------------------------
async function verificarDocumentos(feriasId, modalEl) {
  try {
    const data = await fetchJson(`/rm_ferias_lancadas/${feriasId}/verificar_documentos`);

    [
      { tipo: "aviso_de_ferias", prefix: "aviso-ferias" },
      { tipo: "recibo_de_ferias", prefix: "recibo-ferias" },
    ].forEach(({ tipo, prefix }) => {
      const nomeEl  = modalEl.querySelector(`#${prefix}-nome-${feriasId}`);
      const linkEl  = modalEl.querySelector(`#${prefix}-link-${feriasId}`);
      const atualEl = modalEl.querySelector(`#${prefix}-atual-${feriasId}`);
      const upEl    = modalEl.querySelector(`#${prefix}-upload-${feriasId}`);

      if (data[`${tipo}_anexado`]) {
        if (nomeEl) nomeEl.textContent = data[`${tipo}_nome`] ?? "documento.pdf";
        if (linkEl) linkEl.setAttribute("href", data[`${tipo}_url`] ?? "#");
        atualEl?.classList.remove("hidden");
        upEl?.classList.add("hidden");
      } else {
        atualEl?.classList.add("hidden");
        upEl?.classList.remove("hidden");
      }
    });
  } catch {
    ["aviso-ferias", "recibo-ferias"].forEach((prefix) => {
      modalEl.querySelector(`#${prefix}-atual-${feriasId}`)?.classList.add("hidden");
      modalEl.querySelector(`#${prefix}-upload-${feriasId}`)?.classList.remove("hidden");
    });
  }
}

// -------------------------------------------------------
// Fechar modal
// -------------------------------------------------------
function closeModal(modalEl) {
  if (!modalEl) return;
  const instance = modalEl._modalInstance;
  if (instance?.hide) instance.hide();
  else modalEl.classList.add("hidden");

  document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
  document.body.style.overflow = "";
  document.body.style.paddingRight = "";
  document.body.classList.remove("overflow-hidden", "modal-open");
}

// -------------------------------------------------------
// Abrir modal de documentos
// -------------------------------------------------------
async function handleDocumentosFerias(btn) {
  const url = btn.dataset.url;
  const feriasId = (url ?? "").split("/").pop();
  const modalId = btn.dataset.modalTarget;
  const modalEl = document.getElementById(modalId);

  if (!modalEl) {
    console.error("[ferias-agendadas] Modal não encontrado:", modalId);
    return;
  }

  const form = modalEl.querySelector("form");
  if (form) form.setAttribute("action", url);

  verificarDocumentos(feriasId, modalEl);

  if (window.Modal) {
    const modal = new window.Modal(modalEl);
    modal.show();
    modalEl._modalInstance = modal;
  } else {
    modalEl.classList.remove("hidden");
  }
}

// -------------------------------------------------------
// Remover documento (aviso ou recibo)
// -------------------------------------------------------
async function handleRemoverDocumento(btn, tipo) {
  const modalEl = btn.closest('[id^="documentos-ferias-"]');
  if (!modalEl) return;
  const feriasId = modalEl.id.split("-").pop();

  const result = await swalConfirm({
    title: "Confirmar exclusão",
    text: "Tem certeza que deseja excluir este documento?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sim, excluir",
    cancelButtonText: "Cancelar",
  });
  if (!result.isConfirmed) return;

  const token = csrfToken();
  try {
    const resp = await fetch(`/rm_ferias_lancadas/${feriasId}/remover_documento`, {
      method: "DELETE",
      credentials: "same-origin",
      headers: { "X-CSRF-Token": token, "Content-Type": "application/x-www-form-urlencoded" },
      body: `tipo=${encodeURIComponent(tipo)}`,
    });
    if (!resp.ok) throw resp;

    const prefix = tipo === "aviso_de_ferias" ? "aviso-ferias" : "recibo-ferias";
    modalEl.querySelector(`#${prefix}-atual-${feriasId}`)?.classList.add("hidden");
    modalEl.querySelector(`#${prefix}-upload-${feriasId}`)?.classList.remove("hidden");
    await swalInfo({ title: "Excluído!", text: "O documento foi excluído com sucesso.", icon: "success" });
  } catch {
    await verificarDocumentos(feriasId, modalEl);
    await swalInfo({ title: "Erro!", text: "Ocorreu um problema ao excluir o documento.", icon: "error" });
  }
}

// -------------------------------------------------------
// Submit do formulário de documentos
// -------------------------------------------------------
async function handleFormSubmit(btn) {
  const modalEl = btn.closest('[id^="documentos-ferias-"]');
  if (!modalEl) return;
  const feriasId = modalEl.id.split("-").pop();

  const form = modalEl.querySelector("form");
  const url = form?.getAttribute("action") ?? `/rm_ferias_lancadas/${feriasId}`;

  const avisoUpload  = modalEl.querySelector(`#aviso-ferias-upload-${feriasId}`);
  const reciboUpload = modalEl.querySelector(`#recibo-ferias-upload-${feriasId}`);
  const avisoInput   = modalEl.querySelector(`#rm_ferias_lancadas_aviso_de_ferias_${feriasId}`);
  const reciboInput  = modalEl.querySelector(`#rm_ferias_lancadas_recibo_de_ferias_${feriasId}`);

  const avisoVisivel  = avisoUpload  && !avisoUpload.classList.contains("hidden");
  const reciboVisivel = reciboUpload && !reciboUpload.classList.contains("hidden");
  const temAviso  = (avisoInput?.files?.length ?? 0) > 0;
  const temRecibo = (reciboInput?.files?.length ?? 0) > 0;

  if (avisoVisivel && !temAviso && reciboVisivel && !temRecibo) {
    await swalInfo({
      title: "Atenção!",
      text: "Nenhum documento foi anexado. Por favor, selecione pelo menos um arquivo.",
      icon: "warning",
    });
    return;
  }

  const token = csrfToken();
  if (typeof window.exibe_spinner === "function") window.exibe_spinner();

  try {
    const resp = await fetch(url, {
      method: "PUT",
      credentials: "same-origin",
      headers: { "X-CSRF-Token": token },
      body: new FormData(form),
    });
    if (!resp.ok) throw resp;

    if (typeof window.oculta_spinner === "function") window.oculta_spinner();
    closeModal(modalEl);
    await swalInfo({ title: "Sucesso!", text: "Alterações salvas com sucesso.", icon: "success" });
    turboReload();
  } catch {
    if (typeof window.oculta_spinner === "function") window.oculta_spinner();
    await swalInfo({ title: "Erro!", text: "Ocorreu um erro ao processar sua solicitação.", icon: "error" });
  }
}

// -------------------------------------------------------
// Toggle de campos no filtro (prazo/período/histórico)
// -------------------------------------------------------
export function initFeriasFiltrosToggle(rootEl) {
  const select          = rootEl.querySelector("#filtro_tipo");
  if (!select) return { destroy() {} };

  const camposData      = rootEl.querySelector("#campos_data");
  const camposHistorico = rootEl.querySelector("#campos_historico");
  const form            = rootEl.querySelector("#filtro_periodo_form");

  const DATE_VALUES = new Set([
    "prazo_concessao",
    "inicio_periodo_aquisitivo",
    "fim_periodo_aquisitivo",
    "inicio_periodo_gozo",
    "fim_periodo_gozo",
  ]);

  // Inputs hidden com name (criados pelo ptbr-wrap) ou os originais date
  function hiddenDateInputs() {
    if (!camposData) return [];
    return Array.from(
      camposData.querySelectorAll('input[name="data_inicio"], input[name="data_fim"]')
    );
  }

  function setDataEnabled(enabled) {
    if (!camposData) return;
    if (enabled) {
      camposData.style.opacity       = "";
      camposData.style.pointerEvents = "";
      camposData.title               = "";
    } else {
      camposData.style.opacity       = "0.45";
      camposData.style.pointerEvents = "none";
      camposData.title               = "Selecione um tipo de filtro para habilitar as datas";
    }
  }

  function toggle() {
    const val          = select.value;
    const isHistorico  = val === "historico_ferias";
    const isTodos      = val === "todos";
    const isDateOption = DATE_VALUES.has(val);

    // Mostrar/ocultar seções
    camposData?.classList.toggle("hidden", isHistorico);
    camposHistorico?.classList.toggle("hidden", !isHistorico);

    // Habilitar/bloquear campos de data
    setDataEnabled(isDateOption && !isTodos);
  }

  // Validação antes de submeter
  function onSubmit(e) {
    const val = select.value;

    if (val === "todos") {
      e.preventDefault();
      window.location.href = form.action; // redireciona para URL limpa (sem filtros)
      return;
    }

    if (val === "historico_ferias") {
      const idInput = rootEl.querySelector("#funcionario_id");
      if (!idInput || !idInput.value) {
        e.preventDefault();
        const nomeInput = rootEl.querySelector("#funcionario_nome");
        if (nomeInput && nomeInput.value.trim()) {
          // User typed something but didn't select from dropdown
          if (typeof window.Swal !== "undefined") {
            Swal.fire({
              title: "Selecione um funcionário",
              text: "Por favor, selecione um funcionário da lista de sugestões.",
              icon: "warning",
              confirmButtonColor: "#3b82f6",
              confirmButtonText: "Ok",
            });
          } else {
            alert("Por favor, selecione um funcionário da lista de sugestões.");
          }
        } else {
          if (typeof window.Swal !== "undefined") {
            Swal.fire({
              title: "Funcionário obrigatório",
              text: "Digite o nome do funcionário e selecione uma opção para consultar o histórico.",
              icon: "warning",
              confirmButtonColor: "#3b82f6",
              confirmButtonText: "Ok",
            });
          } else {
            alert("Digite o nome do funcionário e selecione uma opção para consultar o histórico.");
          }
        }
        return;
      }
      return; // ID preenchido, pode submeter
    }

    if (!DATE_VALUES.has(val)) return;
    const filled = hiddenDateInputs().filter(i => i.value);
    if (filled.length > 0) return;

    e.preventDefault();
    if (typeof window.Swal !== "undefined") {
      Swal.fire({
        title: "Data obrigatória",
        text:  "Preencha ao menos o campo \"De\" ou \"Até\" para filtrar.",
        icon:  "warning",
        confirmButtonColor: "#3b82f6",
        confirmButtonText:  "Ok",
      });
    } else {
      alert("Preencha ao menos o campo \"De\" ou \"Até\" para filtrar.");
    }
  }

  // Estado inicial (respeita params da URL ao voltar com filtro ativo)
  toggle();

  select.addEventListener("change", toggle);
  form?.addEventListener("submit", onSubmit);

  return {
    destroy() {
      select.removeEventListener("change", toggle);
      form?.removeEventListener("submit", onSubmit);
    },
  };
}

// -------------------------------------------------------
// Autocomplete — Histórico de Férias (busca de funcionário)
// -------------------------------------------------------
export function initHistoricoAutocomplete(rootEl) {
  const camposHistorico = rootEl.querySelector("#campos_historico");
  if (!camposHistorico) return { destroy() {} };

  const textInput = camposHistorico.querySelector("#funcionario_nome");
  const idInput   = camposHistorico.querySelector("#funcionario_id");
  if (!textInput || !idInput) return { destroy() {} };

  // Dropdown container
  const dropdown = document.createElement("div");
  dropdown.className = [
    "absolute z-50 top-full left-0 right-0 mt-1",
    "bg-white border border-gray-200 rounded-lg shadow-xl",
    "max-h-64 overflow-y-auto hidden",
  ].join(" ");
  textInput.parentElement.appendChild(dropdown);

  let debounceTimer = null;
  let results       = [];
  let selectedIndex = -1;

  function closeDropdown() {
    dropdown.classList.add("hidden");
    selectedIndex = -1;
  }

  function renderItems() {
    if (results.length === 0) {
      dropdown.innerHTML = '<div class="px-4 py-3 text-sm text-gray-500 italic">Nenhum funcionário encontrado.</div>';
    } else {
      dropdown.innerHTML = results.map((r, i) => {
        const nome = r[0] ?? "";
        const isActive = i === selectedIndex ? "bg-blue-50" : "hover:bg-gray-50";
        return `<div class="autocomplete-item px-4 py-2.5 cursor-pointer transition-colors ${isActive}"
                     data-id="${r[1]}" data-nome="${nome}">
                  <span class="text-sm font-medium text-gray-800">${nome}</span>
                </div>`;
      }).join("");
    }
    dropdown.classList.remove("hidden");
  }

  function selectItem(nome, id) {
    textInput.value = nome;
    idInput.value   = id;
    closeDropdown();
  }

  async function fetchSuggestions(term) {
    if (term.length < 3) { closeDropdown(); return; }
    try {
      const resp = await fetch(
        `/rm_funcionarios/auto_complete?term=${encodeURIComponent(term)}`,
        { credentials: "same-origin" }
      );
      const data = await resp.json();
      results = data.results || [];
      renderItems();
    } catch {
      results = [];
      closeDropdown();
    }
  }

  function onInput() {
    idInput.value = ""; // limpa seleção ao digitar
    const term = textInput.value.trim();
    if (term.length < 3) { clearTimeout(debounceTimer); closeDropdown(); return; }
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => fetchSuggestions(term), 220);
  }

  function onKeydown(e) {
    if (dropdown.classList.contains("hidden")) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      selectedIndex = Math.min(selectedIndex + 1, results.length - 1);
      renderItems();
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      selectedIndex = Math.max(selectedIndex - 1, -1);
      renderItems();
    } else if (e.key === "Enter") {
      if (selectedIndex >= 0 && results[selectedIndex]) {
        e.preventDefault();
        selectItem(results[selectedIndex][0], results[selectedIndex][1]);
      }
    } else if (e.key === "Escape") {
      closeDropdown();
    }
  }

  function onDropdownClick(e) {
    const item = e.target.closest(".autocomplete-item");
    if (!item) return;
    selectItem(item.dataset.nome, item.dataset.id);
  }

  function onDocumentClick(e) {
    if (!camposHistorico.contains(e.target)) closeDropdown();
  }

  textInput.addEventListener("input",   onInput);
  textInput.addEventListener("keydown", onKeydown);
  dropdown.addEventListener("click",    onDropdownClick);
  document.addEventListener("click",    onDocumentClick);

  return {
    destroy() {
      textInput.removeEventListener("input",   onInput);
      textInput.removeEventListener("keydown", onKeydown);
      dropdown.removeEventListener("click",    onDropdownClick);
      document.removeEventListener("click",    onDocumentClick);
      clearTimeout(debounceTimer);
    },
  };
}

// -------------------------------------------------------
// Feedback visual ao selecionar arquivo no upload zone
// -------------------------------------------------------
function handleFileInputChange(input) {
  const label = input.closest("[data-upload-label]");
  if (!label) return;

  const nameEl = label.querySelector("[data-file-name]");
  const hintEl = label.querySelector("[data-file-hint]");
  const iconEl = label.querySelector("[data-upload-icon]");
  const file   = input.files?.[0];

  if (file) {
    const size = file.size > 1024 * 1024
      ? `${(file.size / (1024 * 1024)).toFixed(1)} MB`
      : `${Math.round(file.size / 1024)} KB`;

    if (nameEl) { nameEl.textContent = file.name; nameEl.classList.add("text-blue-700"); nameEl.classList.remove("text-gray-600"); }
    if (hintEl) { hintEl.textContent = size; hintEl.classList.add("text-blue-500"); hintEl.classList.remove("text-gray-400"); }
    if (iconEl) { iconEl.classList.add("text-blue-500"); iconEl.classList.remove("text-gray-400"); }
    label.classList.add("border-blue-400", "bg-blue-50/60");
    label.classList.remove("border-gray-300", "bg-white");
  } else {
    if (nameEl) { nameEl.textContent = "Clique para selecionar o arquivo"; nameEl.classList.remove("text-blue-700"); nameEl.classList.add("text-gray-600"); }
    if (hintEl) { hintEl.textContent = "PDF, JPG ou PNG"; hintEl.classList.remove("text-blue-500"); hintEl.classList.add("text-gray-400"); }
    if (iconEl) { iconEl.classList.remove("text-blue-500"); iconEl.classList.add("text-gray-400"); }
    label.classList.remove("border-blue-400", "bg-blue-50/60");
    label.classList.add("border-gray-300", "bg-white");
  }
}

// -------------------------------------------------------
// Modal de upload de aviso para registros PENDENTES
// -------------------------------------------------------
function openAvisoPendenteModal(modalEl) {
  if (!modalEl) return;
  // Preenche o token CSRF no form antes de abrir
  const form = modalEl.querySelector("form");
  if (form) {
    const tokenEl = form.querySelector('input[name="authenticity_token"]');
    const meta = document.querySelector('meta[name="csrf-token"]');
    if (tokenEl && meta) tokenEl.value = meta.getAttribute("content");
  }
  modalEl.classList.remove("hidden");
  modalEl.classList.add("flex");
  document.body.style.overflow = "hidden";
}

function closeAvisoPendenteModal(modalEl) {
  if (!modalEl) return;
  modalEl.classList.add("hidden");
  modalEl.classList.remove("flex");
  document.body.style.overflow = "";
  // Limpa o form e mensagens de erro
  const form = modalEl.querySelector("form");
  if (form) form.reset();
  const erro = modalEl.querySelector('[id^="aviso-pendente-erro-"]');
  if (erro) { erro.textContent = ""; erro.classList.add("hidden"); }
}

async function handleSalvarAvisoPendente(btn) {
  const formId   = btn.dataset.formId;
  const erroId   = btn.dataset.erroId;
  const modalId  = btn.dataset.modalId;
  const form     = document.getElementById(formId);
  const erroEl   = document.getElementById(erroId);
  const modalEl  = document.getElementById(modalId);

  if (!form) return;

  const fileInput = form.querySelector('input[type="file"]');
  if (!fileInput || !fileInput.files.length) {
    if (erroEl) { erroEl.textContent = "Selecione um arquivo antes de salvar."; erroEl.classList.remove("hidden"); }
    return;
  }

  btn.disabled = true;
  btn.textContent = "Salvando...";

  const data = new FormData(form);
  try {
    const resp = await fetch(form.action, {
      method: "POST",  // FormData com _method=patch → Rails interpreta como PATCH
      body: data,
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    });
    const json = await resp.json().catch(() => ({}));
    if (resp.ok && json.success) {
      closeAvisoPendenteModal(modalEl);
      // Atualiza ícone de clip para indicar que há aviso anexado
      if (typeof Swal !== "undefined") {
        await Swal.fire({ icon: "success", title: "Aviso anexado!", timer: 1500, showConfirmButton: false });
      }
      turboReload();
    } else {
      const msg = json.error || "Falha ao salvar. Tente novamente.";
      if (erroEl) { erroEl.textContent = msg; erroEl.classList.remove("hidden"); }
    }
  } catch {
    if (erroEl) { erroEl.textContent = "Erro de conexão. Tente novamente."; erroEl.classList.remove("hidden"); }
  } finally {
    btn.disabled = false;
    btn.textContent = "Salvar";
  }
}

// -------------------------------------------------------
// Inicialização — delegação de eventos no rootEl
// -------------------------------------------------------
export function initFeriasAgendadasActions(rootEl) {
  function handler(e) {
    const accordion = e.target.closest(".accordion-ferias-btn");
    if (accordion) { e.preventDefault(); handleAccordion(accordion); return; }

    const cancelar = e.target.closest(".cancelar-ferias");
    if (cancelar) { e.preventDefault(); handleCancelarFerias(cancelar); return; }

    const reagendar = e.target.closest(".reagendar-ferias");
    if (reagendar) { e.preventDefault(); handleReagendar(reagendar); return; }

    const documentos = e.target.closest(".documentos-ferias");
    if (documentos) { e.preventDefault(); handleDocumentosFerias(documentos); return; }

    const avisoDelete = e.target.closest('[id^="aviso-ferias-delete-"]');
    if (avisoDelete) { e.preventDefault(); handleRemoverDocumento(avisoDelete, "aviso_de_ferias"); return; }

    const reciboDelete = e.target.closest('[id^="recibo-ferias-delete-"]');
    if (reciboDelete) { e.preventDefault(); handleRemoverDocumento(reciboDelete, "recibo_de_ferias"); return; }

    const submit = e.target.closest(".form-submit");
    if (submit) { e.preventDefault(); handleFormSubmit(submit); return; }

    const close = e.target.closest(".modal-close");
    if (close) {
      e.preventDefault();
      closeModal(close.closest('[id^="documentos-ferias-"]'));
      return;
    }

    // ── Modal upload aviso pendente ──────────────────────────────────────
    // Botão que abre o modal (tem data-modal-target="aviso-pendente-ID")
    const abrirAviso = e.target.closest('[data-modal-target^="aviso-pendente-"]');
    if (abrirAviso && !abrirAviso.classList.contains("js-fechar-aviso-pendente") &&
        !abrirAviso.classList.contains("js-salvar-aviso-pendente")) {
      e.preventDefault();
      const modalId = abrirAviso.dataset.modalTarget;
      openAvisoPendenteModal(document.getElementById(modalId));
      return;
    }

    // Botão fechar (X e Cancelar)
    const fecharAviso = e.target.closest(".js-fechar-aviso-pendente");
    if (fecharAviso) {
      e.preventDefault();
      closeAvisoPendenteModal(document.getElementById(fecharAviso.dataset.modalId));
      return;
    }

    // Botão salvar
    const salvarAviso = e.target.closest(".js-salvar-aviso-pendente");
    if (salvarAviso) { e.preventDefault(); handleSalvarAvisoPendente(salvarAviso); return; }

    // Fechar clicando no backdrop (fora do dialog)
    if (e.target.matches('[id^="aviso-pendente-"]')) {
      closeAvisoPendenteModal(e.target);
      return;
    }
  }

  function changeHandler(e) {
    if (e.target.type === "file" && e.target.closest('[id^="documentos-ferias-"]')) {
      handleFileInputChange(e.target);
    }
  }

  rootEl.addEventListener("click", handler);
  rootEl.addEventListener("change", changeHandler);
  return {
    destroy() {
      rootEl.removeEventListener("click", handler);
      rootEl.removeEventListener("change", changeHandler);
    },
  };
}
